/* eslint-disable @next/next/no-img-element */
// libraries
import Link from 'next/link';
import React, { useState } from 'react';
import { BsEye } from 'react-icons/bs';
import { FaPlay } from 'react-icons/fa';
// utils
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { NumeroFormatado, arrumaData, removerAcentos, toPrice } from '../../../utils/FunctionsGlobals';
import styles from './CardApartamentHorizontal.module.css';

const CardApartamentHorizontal: React.FC<{
    slide: any;
    i: number;
    stylesCard?: any;
    site: any;
    allViewProperties: Array<any>;
    activeCachePage?: () => void;
    favorito: any;
    setFavorito: any;
}> = ({ slide, i, stylesCard, site, allViewProperties, activeCachePage, favorito, setFavorito }) => {
    // constants
    const validationSaleDiscount =
        slide?.venda > 0
            ? slide?.preco_especial?.preco_especial_venda > 0
            : null;
    const validationRentDiscount =
        slide?.aluguel > 0
            ? slide?.preco_especial?.preco_especial_locacao > 0
            : null;
    const discountSaleActual =
        slide?.venda > 0 ? slide?.preco_especial?.preco_especial_venda : null;
    const discountRentActual =
        slide?.aluguel > 0
            ? slide?.preco_especial?.preco_especial_locacao
            : null;

    // useState
    const [newIdCard, setNewIdCard] = useState<any>([]);
    const include_favorito = (imovel: any) => {
        if(imovel){
            const fav = favorito.concat(imovel)
            setFavorito(fav);
        }
    }

    const delete_favorito = (imovel: any) => {
        if(favorito?.length <= 1) {
            window.localStorage.removeItem('favoritos');
            setFavorito([])
        }else{
            const index = favorito.indexOf(imovel);
            if(index > -1) {
                let renderArray: any = [];
                favorito.map((x:any, count: number) => {
                    if(count != index){
                        renderArray.push(favorito[count])
                    }
                })
                setFavorito(renderArray);
            }
        }
    }

    const renderPath = () => {
        const validationModelSale = slide?.venda ? 'venda' : '';
        const validationModelRent = slide?.aluguel ? 'aluguel' : '';
        const validationModel =
            validationModelSale || validationModelRent || 'venda';
        const newPath = `/imoveis/${validationModel}/${
            slide?.cidade?.nome ? slide?.cidade?.nome.replaceAll('-', '002D').replaceAll('/', '-').replaceAll('?', '-') : '-'
        }/${slide?.bairro?.nome ? slide?.bairro?.nome.replaceAll('/', '-').replaceAll('?', '-') : '-'}/${site?.exibir_empreendimento ? slide?.empreendimento?.nome?.replaceAll("\n", '-') || '-' : '-'}/${
            slide?.tipo?.nome
                ? slide?.tipo?.nome.replaceAll('-', '002D').replaceAll('/', '_')
                : '-'
        }/${
            slide?.referencia
                ? slide?.referencia.replaceAll('-', '002D').replaceAll('/', '_')
                : '-'
        }/imovel/${slide?.id}`.replaceAll(' ', '-');
        return removerAcentos(newPath).toLowerCase();
    };

    const GetPhoto = slide?.fotos?.url_foto ? slide?.fotos : slide?.fotos?.length > 0 ? slide?.fotos?.find((v: any) => v.destaque === true) : "";

    return (
        <a
            className={styles.card}
            onClick={activeCachePage ? activeCachePage : () => null}
        >
            <div
                className={styles.photo}
                key={i}
                onMouseEnter={() => {
                    setNewIdCard([...newIdCard, slide?.id]);
                }}
                onMouseLeave={() => {
                    if (newIdCard.includes(slide?.id)) {
                        const newCards = newIdCard.filter(
                            (v: any) => v !== slide?.id
                        );
                        setNewIdCard(newCards);
                    }
                }}
            >
                { favorito.indexOf(slide?.id) >= 0 ?
                    <div className={styles.adjust_favorito}>
                        <div
                            className={styles.favorito}
                        >
                            <FaHeart size={25} color={site?.cor2} onClick={() => delete_favorito(slide?.id)} className={styles.favorito_icon}/>
                        </div>
                    </div>
                :
                    <div className={styles.adjust_favorito}>
                        <div
                            className={styles.favorito}
                        >
                            <FaRegHeart size={25} onClick={() => include_favorito(slide?.id)} color={site?.cor2} className={styles.favorito_icon}/>
                        </div>
                    </div>
                }
                <Link href={renderPath()} passHref>
                <div style={{display: "flex"}}>
                    {GetPhoto?.url_foto ? (
                        <div
                            className={
                                stylesCard
                                    ? styles.photo_empty_mini
                                    : styles.photo_empty
                            }
                        >
                            <img
                                src={GetPhoto?.url_foto.replaceAll("_g","_m")}
                                alt={`${slide?.tipo?.nome} em ${slide?.bairro?.nome} - ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`}
                                className={
                                    stylesCard
                                        ? styles.photo_position_mini
                                        : styles.photo_position
                                }
                            />

                            { slide?.link_video ?
                                <div className={styles.background_animation1}>
                                    <FaPlay size={100} color="#ffffffb5" />
                                </div>
                                : null
                            }

                            { allViewProperties?.includes(slide?.id) ? (
                                <div className={styles.container_view}>
                                    <BsEye
                                        size={14}
                                        color="white"
                                        style={{ marginRight: 5, marginTop: 2 }}
                                    />
                                    <label>Visualizado</label>
                                </div>
                            ) : null}

                        </div>
                    ) : (
                        <div
                            className={
                                stylesCard
                                    ? styles.photo_empty_mini
                                    : styles.photo_empty
                            }
                        >
                            <img
                                src={'https://fotos.sobressai.com.br/Fotos/imovel_sem_foto.jpg'}
                                alt={`${slide?.tipo?.nome} em ${slide?.bairro?.nome} - ${slide?.cidade?.nome}, Referencia: ${slide?.referencia}`}
                                className={
                                    stylesCard
                                        ? styles.photo_position_mini
                                        : styles.photo_position
                                }
                            />

                            { slide?.link_video  ?
                                <div className={styles.background_animation1}>
                                    <FaPlay size={100} color="#ffffffb5" />
                                </div>
                                : null
                            }

                            { allViewProperties?.includes(slide?.id) ? (
                                <div className={styles.container_view}>
                                    <BsEye
                                        size={14}
                                        color="white"
                                        style={{ marginRight: 5, marginTop: 2 }}
                                    />
                                    <label>Visualizado</label>
                                </div>
                            ) : null}

                        </div>
                    )}
                <div className={styles.container_info}>
                    <div
                        className={styles.linha1}
                        >
                            {slide?.mini_banner_texto ?
                            <div
                                className={styles.codigoImovel} style={site?.id == "2014" ? {background: "#000000"} : {background: "#ba1319"}}
                            >
                                <label>{slide?.mini_banner_texto}</label>
                            </div>
                            :
                            slide?.link_video && ((slide?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && slide?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ?
                                <div
                                    className={styles.codigoImovel} style={site?.id == "2014" ? {background: "#000000"} : {background: "#ba1319"}}
                                >
                                    <label>Imóvel com Vídeo</label>
                                </div>
                            : null
                        }

                        { site?.id != "1946" && site?.id != "1918" && site?.id != "1968" ?
                            <div
                                className={styles.codigoImovel}
                                style={{
                                    background: `${site?.cor2 || 'green'}`,
                                    color: site?.id == "2126" ? "white" : site?.cor4,
                                }}
                            >
                                <label>{`Código: ${slide?.referencia}`}</label>
                            </div>
                        : null }
                    </div>

                    <div className={styles.linha2}>
                        <div className={styles.adjust_icon}>
                            <label className={styles.txt}>
                                {site?.id == 2122 && slide?.empreendimento?.nome ? slide?.empreendimento?.nome : slide?.tipo?.nome && slide?.cidade?.nome ? slide?.tipo?.nome + ' em ' + slide?.cidade?.nome : slide?.titulo }
                            </label>
                        </div>
                    </div>

                    <div className={styles.linha3}>
                        <div className={styles.linha3}>
                            {slide?.dormitorios ? (
                                <div className={styles.adjust_icons}>
                                    <svg
                                        viewBox="0 0 640 512"
                                        height="14px"
                                        width="14px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                                        ></path>
                                    </svg>
                                    <label className={styles.margin}>
                                        {slide?.dormitorios == 1 ? "1 Quarto" : slide?.dormitorios+" Quartos"}
                                        {slide?.suites > 0 ?
                                            slide?.suites == 1 ? " (1 Suíte)" : " ("+slide?.suites+" Suítes)" : null
                                        }
                                    </label>
                                </div>
                            ) : null}
                            {slide?.garagems ? (
                                <div className={styles.adjust_icons}>
                                    <svg
                                        viewBox="0 20 512 512"
                                        height="14px"
                                        width="14px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                                        ></path>
                                    </svg>
                                    <label className={styles.margin}>
                                        {slide?.garagems ? `${slide?.garagems} Vagas` : `${slide?.garagems} Vaga`}
                                    </label>
                                </div>
                            ) : null}
                            { slide?.banheiros ?
                                <div className={styles.adjust_icons}>
                                    <svg
                                        viewBox="0 20 512 512"
                                        height="14px"
                                        width="14px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M32 384a95.4 95.4 0 0 0 32 71.09V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h256v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-40.91A95.4 95.4 0 0 0 480 384v-48H32zm464-128H80V69.25a21.26 21.26 0 0 1 36.28-15l19.27 19.26c-13.13 29.88-7.61 59.11 8.62 79.73l-.17.17a16 16 0 0 0 0 22.59l11.31 11.31a16 16 0 0 0 22.63 0L283.31 81.94a16 16 0 0 0 0-22.63L272 48a16 16 0 0 0-22.62 0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62l-19.26-19.27A69.25 69.25 0 0 0 32 69.25V256H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
                                        ></path>
                                    </svg>
                                    <label className={styles.margin}>
                                        {slide?.banheiros > 1 ? `${slide?.banheiros} Banheiros` : `${slide?.banheiros} Banheiro`}
                                    </label>
                                </div>
                            : null }
                            { slide?.area_total > 0 ? (
                                <div className={styles.adjust_icons}>
                                    <svg
                                        viewBox="0 20 512 512"
                                        height="14px"
                                        width="14px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                                        ></path>
                                    </svg>
                                    <label className={styles.margin}>
                                        {NumeroFormatado(Number(slide?.area_total)) + " " + (slide?.area_tipo || 'm²')}
                                    </label>
                                </div>
                            ) : (
                                slide?.terreno > 0 ? (
                                    <div className={styles.adjust_icons}>
                                        <svg
                                            viewBox="0 20 512 512"
                                            height="14px"
                                            width="14px"
                                            aria-hidden="true"
                                            focusable="false"
                                            fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="StyledIconBase-ea9ulj-0 fHrGFt"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                                            ></path>
                                        </svg>
                                        <label className={styles.margin}>
                                            {NumeroFormatado(Number(slide?.terreno)) + " " + (slide?.area_tipo || 'm²')}
                                        </label>
                                    </div>
                                ) : null
                            )}
                        </div>
                    </div>

                    <div className={styles.linha4}>
                            {slide?.descricao ? (
                            <h4 className={styles.description_properties}>

                                {slide?.descricao}

                            </h4>
                            ) : null}
                    </div>

                    { slide?.temporada && slide?.d1 > 0 ? (
                        <div
                            className={ styles.adjust_price }
                        >
                            <p className={ styles.price } >
                                {site?.id != '1667' ?
                                    <>
                                    Diária:
                                        {` ${site?.moeda_tipo} ${toPrice(
                                            slide?.d1,
                                            2
                                        )}`}
                                    </>
                                : <>Diária: Sob Consulta</>}
                            </p>
                        </div>
                    )
                    : null}
                    { slide?.exibir_preco_locacao && slide?.preco_locacao > 0 ? (
                        <div
                            className={
                                validationRentDiscount
                                    ? styles.adjust_icon
                                    : styles.adjust_price
                            }
                        >
                            <p
                                className={
                                    validationRentDiscount
                                        ? styles.text_decoration
                                        : styles.price
                                }
                            >
                                Aluguel:
                                {validationRentDiscount
                                    ? ` De: ${site?.moeda_tipo} ${toPrice(
                                            slide?.preco_locacao,
                                            2
                                        )}`
                                    : ` ${site?.moeda_tipo} ${toPrice(
                                            slide?.preco_locacao,
                                            2
                                        )}`}
                            </p>
                            <br></br>
                            {validationRentDiscount ? (
                                <label className={styles.price}>
                                    {`Por: ${site?.moeda_tipo} ${toPrice(
                                        discountRentActual,
                                        2
                                    )}`}
                                </label>
                            ) : null}
                        </div>
                    ) : null}
                    {Number(
                        slide?.exibir_preco_venda && slide?.preco_venda > 0
                    ) ? (
                        validationSaleDiscount ?
                            <div className={styles.adjust_icon}>
                                <div className={styles.line}>
                                    <p className={styles.text_decoration_limpo}>Venda de:</p>
                                    <p className={styles.text_decoration}>
                                        {` ${site?.moeda_tipo} ${toPrice(
                                                slide?.preco_venda,
                                                2
                                            )}`}
                                    </p>
                                </div>
                                <label className={styles.price}>
                                    {`Por: ${site?.moeda_tipo} ${toPrice(
                                        discountSaleActual,
                                        2
                                    )}`}
                                </label>
                            </div>
                        :   <div
                                className={styles.adjust_price}
                            >
                                <div
                                    className={styles.price}
                                >
                                    {`Venda: ${site?.moeda_tipo} ${toPrice(
                                            slide?.preco_venda,
                                            2
                                        )}`}
                                </div>
                            </div>

                    ) : (!slide?.exibir_preco_locacao || slide?.preco_locacao<1) && (!slide?.temporada || slide?.d1<1) ? (
                        <div className={styles.adjust_price}>
                            <p className={styles.price}>
                                Valor: Sob Consulta
                            </p>
                        </div>
                    ) : null}
                    {site?.id == "1892" && slide?.data_edicao ?
                        <div className={styles.data_edicao}>Data última edição: {arrumaData(slide?.data_edicao)}</div>
                    : null}
                </div>

                </div>
                </Link>
            </div>
        </a>
    );
};

export default CardApartamentHorizontal;
